import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import type { RecommendedArticlesBlockProps } from '../interfaces';
import ArticleItem from './ArticleItem';

const RecommendedArticlesBlock = ({
  config,
  recommendedArticles,
}: RecommendedArticlesBlockProps) => {
  const { Track, trackEvent } = useEventTracking({
    ...(config?.analytics_location ? { location: config.analytics_location } : {}),
  });

  return (
    <article className="recommended-articles-block mt-64 sm:mt-96 md:mt-112">
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          if (config?.impression_tracking) {
            inView &&
              trackEvent(impression({ impressionElement: ImpressionElement.MostPopularArticles }));
          }
        }}
      >
        <header>
          <h2 className="m-0 font-suisse-intl-mono text-caption-lg font-normal text-grayscale-gray">
            Popular Articles
          </h2>
        </header>
        <div className="-mx-16 mt-8 flex flex-row flex-nowrap gap-32 overflow-x-auto px-16 sm:mx-0 sm:mt-16 sm:flex-wrap sm:overflow-x-hidden sm:px-0 nav:flex-nowrap">
          <Track>
            {recommendedArticles.map((article) => (
              <ArticleItem key={article.id} article={article} />
            ))}
          </Track>
        </div>
      </InView>
    </article>
  );
};

export default RecommendedArticlesBlock;
